export default __webpack_public_path__ + "static/media/comic8_1.a3da6439.png";